var CONFUSEDCORE = CONFUSEDCORE || {};
CONFUSEDCORE.AJAX = CONFUSEDCORE.AJAX || {};

//@desc: acts as a wrapper to jQuery's ajax call
CONFUSEDCORE.AJAX.Ajaxfacade = (function($){

	function userIsLoggedIn(response){
		if(response && response.Authenticated === false){
			//force page refresh to re-authenticate
			window.location.reload();
			return false;
		}

		return true;
	}

	function error(options, xhr, textStatus, errorThrown){
		if(!options) { return; }

		if(options.error) {
			options.error(xhr, textStatus, errorThrown);
		}
	}

	return {

		/*
		@desc: posts data to the specified url
		@param options:
		@param options.success: the success callback
		@param options.error: the error callback
		@param options.timeout: the timeout callback
		@param options.requiresAuthentication: if true, checks authentication status and redirects if logged out
		@param options.async: whether to post asynchronously, default: true
        @param options.dataType: json, html etc.
        @param options.wrappedResponse: whether the response will be wrapped in a JsonResponse<T> or not
		@param data: the data to pass through in the post
		 */
		post: function(url, options, data) {

			if(!options.timeoutInterval){
				//if it hasn't been specified then set it to 5s
				options.timeoutInterval = 5000;  				
			}

			if(options.async === null || options.async === undefined){
				//default to true
				options.async = true;
			}

			if (!options.dataType) {
			    options.dataType = 'json';
			}
			if (options.wrappedResponse === undefined) {
			    options.wrappedResponse = true;
			}


			$.ajax({
				type: 'POST',
				url: url,
				data: data,
				dataType: options.dataType,
				timeout: options.timeoutInterval, // in milliseconds
				async: options.async,
				success: function (response) {
				    if (response !== null && response !== undefined) {
				        var redirect = null;
                        // eslint-disable-next-line no-prototype-builtins
                        if (response.hasOwnProperty('redirect')) {
                            redirect = response.redirect; //returned from a session timeout in a call expecting JSON, for example
                        } else if (response.toString().indexOf('redirect') >= 0) {
                            try {
                                redirect = JSON.parse(response).redirect; //returned from a session timeout in a call expecting HTML, for example
                            } catch (e) { /* empty */ }
                        }
                        if (redirect !== null) {
                            //AJAX call returned a redirect.  Redirect the window to the redirect location
                            document.location = redirect;
                            return;
                        }
				    }
				    if (options.wrappedResponse) {
				        if (!response || response.Status !== 'ok') {
				            error(options);
				            return;
				        }

				        if (!options) {
				            return;
				        }

				        if (options.requiresAuthentication) {
				            if (!userIsLoggedIn(response)) {
				                return;
				            }
				        }

				        if (options.success) {
				            options.success(response.Data);
				        }
				    } else {
				        options.success(response);
				    }
				},
				error: function(xhr, textStatus, errorThrown) {
					if(textStatus === 'timeout' && options && options.timeout){
						options.timeout();
						return;
					}

					error(options, xhr, textStatus, errorThrown);
				},
				complete: function () {
				    if (typeof options.complete !== 'undefined') {
				        options.complete();
				    }
                }
			});		

		},

		/*
		@desc: posts data to the specified url. The user must be authenticated
		@param options:
		@param options.success: the success callback
		@param options.error: the error callback
		@param options.async: whether to post asynchronously, default: true
		@param data: the data to pass through in the post
		 */
		postAuthenticated: function (url, options, data) {
            if (!options) {
                options = {};
            }

			options.requiresAuthentication = true;
			this.post(url, options, data);
		}

	};

}(window.jQuery));